export enum Content {
    APP_TITLE = 'koppelcode-invoeren.app-title',
    EXPIRED_CODE = 'koppelcode-invoeren.validations.expired',
    INPUT_LABEL = 'koppelcode-invoeren.input.label',
    INVALID_CODE = 'koppelcode-invoeren.validations.invalid',
    PARAGRAPH = 'koppelcode-invoeren.paragraph',
    SAMEN_REKENING_OPENEN_MOBILE_URL = 'samen-rekening-openen.mobile.url',
    SAMEN_REKENING_OPENEN_RETAIL_URL = 'samen-rekening-openen.retail.url',
    SUBMIT_BUTTON = 'koppelcode-invoeren.submit-button.label',
    TITLE = 'koppelcode-invoeren.title'
}

export const content: Record<Content, Record<string, string>> = {
    [Content.APP_TITLE]: {
        default: 'Koppelcode'
    },
    [Content.INPUT_LABEL]: {
        default: 'Koppelcode'
    },
    [Content.INVALID_CODE]: {
        default: 'De koppelcode is onjuist. Controleer de code en probeer het opnieuw.'
    },
    [Content.EXPIRED_CODE]: {
        default: 'De koppelcode die je net hebt ingevuld is al een keer gebruikt of niet meer geldig.'
    },
    [Content.PARAGRAPH]: {
        default: 'Vul de koppelcode in die je hebt ontvangen.',
        sns: 'Vul de koppelcode in die je van ons hebt gekregen.'
    },
    [Content.SAMEN_REKENING_OPENEN_MOBILE_URL]: {
        default: '/online/mobiel/samen-rekening-openen'
    },
    [Content.SAMEN_REKENING_OPENEN_RETAIL_URL]: {
        default: '/online/samen-rekening-openen',
        asn: '/producten/koppelcode.html',
        reb: '/opensamen',
        sns: '/particulier/service/open-samen.html'
    },
    [Content.SUBMIT_BUTTON]: {
        default: 'Volgende'
    },
    [Content.TITLE]: {
        default: 'Vul de koppelcode in'
    }
};
